// extracted by mini-css-extract-plugin
module.exports = {"box":"BookingStack--box--3HCx4","max_width":"BookingStack--max_width--3-TeC","fullWidth":"BookingStack--fullWidth--1hUQB"};